import React from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export const FacilityRegistrationTopInfo: React.FunctionComponent = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityRegistrationPage.topInfo.${key}`);

  return (
    <div className="facility-registration-top-info-module">
      <div className="description-txt">{t("description")}</div>
    </div>
  );
};

export default FacilityRegistrationTopInfo;
